import { showAppModule } from './actions';
import { AppModules, type PayloadShowAppModule } from './types';
import {
  action$,
  persistentDerivedStream,
  persistentReducedStream,
  reducer,
  reduceState,
  streamReducer,
} from '@ardoq/rxbeach';
import { notifyWorkspaceChanged } from 'streams/context/ContextActions';
import { distinctUntilChanged, map, pairwise } from 'rxjs/operators';
import { isEqual } from 'lodash';
import { returnPayload } from '@ardoq/common-helpers';

type State = PayloadShowAppModule;

const defaultState = {
  selectedModule: AppModules.HOME,
};

const handleShowAppModule = returnPayload<State>;

const handleNotifyWorkspaceChanged = (state: State): State => {
  if (state.selectedModule === AppModules.VIEWPOINTS) {
    return state;
  }
  return { selectedModule: AppModules.WORKSPACES };
};

// We will soon get better RxBeach tools to create a persistent stream not
// just with some reducers, but also with some operators.
const _selectedModule$ = action$.pipe(
  reduceState('_selectedModule$', defaultState, [
    reducer(showAppModule, handleShowAppModule),
    reducer(notifyWorkspaceChanged, handleNotifyWorkspaceChanged),
  ]),
  distinctUntilChanged((previous, current) => isEqual(previous, current))
);

const selectedModule$ = persistentReducedStream<PayloadShowAppModule>(
  'selectedModule$',
  defaultState,
  [streamReducer(_selectedModule$, returnPayload)]
);

export const previousModule$ = persistentDerivedStream(
  'previousModule$',
  selectedModule$.pipe(
    pairwise(),
    map(([previous, _]) => previous.selectedModule)
  ),
  null
);

export { selectedModule$ };
